import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { formatDate } from "../../utils/formatDate";
import { useGetDeleteActivity } from "../../hooks/useCrm";
import { useResetRecoilState } from "recoil";
import { crmActionCheckListAtom } from "../../shared/crm-action-checklist";
import Typography from "../Typography/Typography";

export const DeleteActivityModal = ({ show, handleClose, dates }) => {
  const [form, setForm] = useState({
    IdActivityCrm: null,
  });
  useEffect(() => {
    setForm({ ...form, IdActivityCrm: dates });
  }, [dates]);

  const resetIds = useResetRecoilState(crmActionCheckListAtom);
  const [button] = useState(false);
  const { mutateAsync: DeleteDate, isLoading: ChangingDate } =
    useGetDeleteActivity();
  const handleChange = async (dates) => {
    await DeleteDate(dates).then(() => {
      resetIds();
      setForm({ ...form, IdActivityCrm: null });
    });
  };

  return (
    <BootstrapModal
      modaltitle="تغییر تاریخ فعالیت ها"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button
          style={{ width: "40px", border: "none" }}
          onclick={() => {
            setForm();
            handleClose();
          }}
        >
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12 mb-2">
          <Typography size="14px">
            آیا از حذف این فعالیت ها مطمئن هستید؟
          </Typography>
        </div>
        <div className="col-6">
          <Button
            className=""
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleChange(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button
            className=""
            bgColor="#f1416c"
            color="#fff"
            onclick={handleClose}
          >
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
